<template>
  <v-avatar
    tile
    :size="size"
    slot="activator"
    @mouseover="mouseHovered = true"
    @mouseleave="mouseHovered = false"
  >
    <img :src="value"  class="border"/>
    <div v-show="mouseHovered" class="image_editLayer" v-if="!readonly">
      <div
        class="image_editLayer"
        style="background: #585858; opacity: 0.2"
      ></div>
      <v-btn
        icon
        v-if="!readonly"
        class="white teal--text"
        @click="$refs.inputFile.click()"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <input
        type="file"
        ref="inputFile"
        data-vv-as="عکس"
        accept="image/*"
        style="display: none"
        @change="onFileChange"
        data-vv-name="userPhoto"
        v-validate="'required|size:4000'"
      />
    </div>
  </v-avatar>
</template>
<script>
export default {
  props: {
    size: { default: 150 },
    readonly: { default: false },
    value: {
      required: true,
      default: require("@/assets/images/userplaceholder.svg"),
    },
  },
  data() {
    return {
      loading: false,
      mouseHovered: false,
    };
  },
  computed: {
    deviceClasses() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return {
          lay1: "primary",
          icon: "mb-5 align-center",
        };
      return {
        lay1: "primary",
        icon: "mb-5 align-center",
      };
    },
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    },
  },
  methods: {
    async onFileChange(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // let formData = new FormData();
          // formData.append("files", this.$refs.inputFile.files[0]);
          // this.axios.post("upload_file", formData, {
                //   headers: {
                //     "Content-Type": "multipart/form-data"
                //   }
                // }).then(async (resp) => {
          //   await this.removeOldImage(false);
          //   this.customer.individual.photo = resp.data.dbPath;
          //   this.customer.individual.image = resp.data.path;
          // });
          let file = this.$refs.inputFile.files[0];
          this.createImage(file);
        } else {
          this.$store.commit("showSnackbar", {
            show: true,
            stateType: "error",
            text: this.errors.collect("userPhoto").toString(),
          });
        }
      });
    },

    async removeOldImage(reset) {
      await this.axios
        .post("remove-file", { file_path: this.value })
        .then((resp) => {
          if (reset) {
            this.value = require("@/assets/images/userplaceholder.svg");
          }
        });
    },

    createImage(file, a) {
      this.$emit("updateFile", file);
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        this.$emit("input", e.target.result);
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style>
.image_editLayer {
  width: 150px;
  height: 150px;
  display: flex;
  position: absolute;
  align-items: flex-end;
  justify-content: space-between;
}
</style>